(function() {
    'use strict';
    angular.module('app')
        .controller('tsunHomeController', tsunHomeController);

    function tsunHomeController(viewModel) {
        var vm = this;

        init();

        function init() {
            vm.data=viewModel.data;
        }
    }
})();